import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { IngresarComponent } from './login/ingresar/ingresar.component';
import { RecuperarpasswordComponent } from './login/recuperarpassword/recuperarpassword.component';
import { PrincipalComponent } from './principal/principal.component';
import { GenerarqrComponent } from './principal/generarqr/generarqr.component';
import { MenuComponent } from './principal/menu/menu.component';
import { ReportesComponent } from './principal/reportes/reportes.component';
import { ReporteDetalleComponent } from './principal/reportes/reporte-detalle/reporte-detalle.component';
import { ReporteDetallePaisComponent } from './principal/reportes/reporte-detalle/reporte-detalle-pais/reporte-detalle-pais.component';
import { UsuarioComponent } from './principal/usuario/usuario.component';
import { RedireccionComponent } from './principal/redireccion/redireccion.component';
import { AuthGuard } from './guards/auth.guard';
import { AdminGuard } from './guards/admin.guard';

const routes: Routes = [
  {path: '',redirectTo:'/login' ,pathMatch:'full'},
  {path: 'login',component:LoginComponent ,children: [
    {path:'', component: IngresarComponent},
    {path:'recuperar-contrasena', component: RecuperarpasswordComponent},
  ]},


  {path: 'principal',component:PrincipalComponent , canActivate: [AuthGuard], children:[
    {path: 'generarqr',component:GenerarqrComponent },
    {path: 'menu',component:MenuComponent },
    {path: 'reportes',component:ReportesComponent },
    {path: 'reportes_detalle', component: ReporteDetalleComponent},
    {path: 'reportes_detalle_pais', component: ReporteDetallePaisComponent},
    {path: 'usuario',component: UsuarioComponent, canActivate: [AdminGuard] },
    {path: 'redireccion',component: RedireccionComponent },
  ]},

  
  {path:'**', redirectTo:'/login', pathMatch:'full'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
